import script from "./TeacherClass.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherClass.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./TeacherClass.vue?vue&type=style&index=1&id=676caf6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676caf6e"]])

export default __exports__